export default __webpack_public_path__ + "static/media/access-forgot.f698770a.jpg";